import React from "react";

export default ({ label }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="32"
    width="32"
    viewBox="0 0 31.999999 31.999998"
    alt={label}
  >
    <path
      d="m18 1025.4c-3.0799 0-5.7489 1.744-7.0859 4.295-2.3808 0.6468-4.3803 2.3585-5.3301 4.7207-3.1442 0.2185-5.5834 2.8326-5.584 5.9843 0 3.3138 2.6863 6 6 6h15.5c3.1818 0 5.8239-2.2873 6.3848-5.3066 2.3897-0.7906 4.1152-3.0385 4.1152-5.6934 0-3.3137-2.6863-6-6-6-0.34255 0-0.68429 0.033-1.0215 0.094-1.4139-2.5269-4.0829-4.0927-6.9785-4.0937zm0 2c2.7877 0 5.2063 1.9254 5.8379 4.6407 0.64435-0.4165 1.3949-0.6386 2.1621-0.6407 2.2091 0 4 1.7909 4 4 0 1.5118-0.84848 2.8121-2.0859 3.4922-0.48535-3.11-3.1679-5.4922-6.4141-5.4922-0.49867 0-0.99543 0.062-1.4805 0.1778-1.3174-2.4222-3.7857-3.966-6.5137-4.1426 1.0994-1.2449 2.7027-2.0352 4.4941-2.0352zm-5 4c2.8668 0 5.3313 2.0326 5.8828 4.8458 0.76276-0.5482 1.6779-0.8439 2.6172-0.8458 2.4853 0 4.5 2.0148 4.5 4.5 0 2.4853-2.0147 4.5-4.5 4.5h-15.5c-2.2091 0-4-1.7908-4-4 0-2.2091 1.7909-4 4-4 0.36119 0.001 0.72057 0.051 1.0684 0.1485 0.4232-2.9517 2.9498-5.1447 5.9316-5.1485z"
      transform="translate(0 -1020.4)"
    />
  </svg>
);
